import { Log } from "../MyHelpers";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { safeSetTimeout, safeClearTimeout } from "./SafeTiming";

export type TimingCallback = () => void;
export interface ITimeout
{
    Name(): string;

    Start(): void;
    Restart(): void;
    Stop(): void;

    /**
     * @return timeout in milliseconds
     */
    //Timeout(): number;

    Running(): boolean;
    GetTimeout(): number;
    ChangeTimeout(timeout : number);
}

export class Timeout implements ITimeout
{
    protected resid: ResourceIdentifier;

    protected running: boolean = false;
    protected timeoutid: number = 0;

    protected callback: TimingCallback = null;
    protected timeout: number = 0;

    public constructor(resid: ResourceIdentifier, callback: TimingCallback, timeout: number)
    {

        this.resid = resid;

        if (callback == null) throw "callback must not be null";
        this.callback = callback;


        if (timeout < 0) throw "timeoutMillis must not be negative";
        this.timeout = timeout;
    }
    

    // public get Timeout(): number
    // {
    //     return this.timeout;
    // }

    // public set Timeout(timeoutMillis: number)
    // {
    //     if (timeoutMillis < 0) throw "timeoutMillis must not be negative";

    //     this.timeout = timeoutMillis;
    // }

    public Timeout(): number
    {
        return this.timeout;
    }

    protected TimeoutTriggered(): void
    {
        //Log.Debug(this.resid.ID(), "Timeout.TimeoutTriggered()");

        this.running = false;
        this.timeoutid = -1;

        this.callback();
    }

    // starts or restarts timer
    public Start(): void
    {

        //Log.Debug(this.resid.ID(), "Timeout.Start() with timeout " + this.timeout + "ms");
        this.InternalStop();

        this.running = true;
        this.timeoutid = safeSetTimeout(() => this.TimeoutTriggered(), this.timeout);
    }

    public Restart(): void
    {
        this.Start();
    }

    public Stop(): void
    {
        //Log.Debug(this.resid.ID(), "Timeout.Stop()");
        this.InternalStop();
    }

    InternalStop()
    {
        if (this.running)
        {
            this.running = false;
            safeClearTimeout(this.timeoutid);
        }
    }

    public Running(): boolean
    {
        return this.running;
    }

    public Name(): string
    {
        return this.resid.ID();
    }

    public GetTimeout(): number
    {
        return this.timeout;
    }

    public ChangeTimeout(timeout : number){
        //Log.Debug(this.resid.ID(), `Timeout.ChangeTimeout() timeout=${timeout}`);
        this.timeout = timeout;
    }
}